var React = require('react');

function Idle (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"inherit","d":"M63 94.975a32 32 0 1 1 32-32 32.036 32.036 0 0 1-32 32z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M63 34.975a28 28 0 1 1-28 28 28.032 28.032 0 0 1 28-28m0-8a36 36 0 1 0 36 36 36 36 0 0 0-36-36z","key":1}),React.createElement("circle",{"cx":"63","cy":"63","r":"63","fill":"none","key":2})]));
}

Idle.defaultProps = {"viewBox":"0 0 126 126"};

module.exports = Idle;

Idle.default = Idle;
